// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1b9ll","right":"Footer_right__hFoKW","buttons":"Footer_buttons__2J1D5"};